
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import OtherNews from "~/components/articles/OtherNews.vue";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";
import {pickSeoTitle} from "~/helpers/seo-title";

export default {
  fetch: async function () {
    await this.getArticle();
    await this.getAllImagesInCmsPage();
  },

  head: function () {
    const title = pickSeoTitle([this.article?.seo_title, this.article?.title], 80);
    const description = this.article?.seo_description
      || this.buildFallbackDescription;

    return {
      __dangerouslyDisableSanitizers: ['script', 'innerHTML'],

      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: `{
            "@context": "https://schema.org",
            "@graph": [${ this.schemaScript }]
          }`
        }
      ]
    }
  },
  data: function () {
    return {
      article: {},
      parsedImages: [],
    }
  },

  computed: {
    breadcrumbs: function () {
      return [
        { title: "Главная", path: "/" },
        { title: "Статьи", path: "/articles" },
        { title: this.article?.title, path: this.$route.fullPath },
      ]
    },
    userCity: function () {
      const city = this.$store.state?.appState?.config?.city?.data?.parental || this.$store.state?.appState?.config?.city?.data?.city_name;

      return `из ${city}`
    },
    cmsPageId: function () {
      return Number.parseFloat(this.article?.cms_page_id || 0)
    },

    articleDate: function () {
      return new Date(this.article?.publish_from * 1000).toLocaleDateString('ru', {
        day: '2-digit',
        month: "long",
        year: 'numeric'
      });
    },

    buildFallbackDescription: function () {
      const source = this.article?.announce || this.article?.content || '';

      return String(source)
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 160);
    },

    schemaScript: function () {
      if (!this.article || Object.keys(this.article || {}).length === 0) {
        return
      }

      const headline = this?.article?.seo_title || '';
      const description = this.article?.seo_description || '';
      const publish_from = new Date(this.article?.publish_from * 1000).toISOString();

      const objectSheme = {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        'mainEntityOfPage': {
          '@type': 'WebPage',
          '@id': `https://centraltrans.ru${this.$route.fullPath}`
        },
        'headline': headline,
        'image': this.parsedImages,
        'datePublished': publish_from,
        'dateModified': publish_from,
        'author': {
          '@type': 'Person',
          'name': 'Central Trans',
          'url': 'https://centraltrans.ru/'
        },
        'publisher': {
          '@type': 'Organization',
          'name': 'Central Trans',
          'logo': {
            '@type': 'ImageObject',
            'url': 'https://centraltrans.ru/_nuxt/assets/img/svg/logos/logo-header.svg?v=1755663386505'
          }
        },
        'description': description
      };
      return String(JSON.stringify(objectSheme) || '');
    }
  },

  components: {
    Breadcrumbs,
    OtherNews
  },

  methods: {
    getArticle: async function () {
      const slug = this.$route?.params?.slug;
      const article = await this.$api.agent.transport.get(`/articles/${ slug }?expand=image,category,tags&category_slug=articles`).then((res) => {
        return res.data
      }).catch((err) => {
        return null
      });
      if (!article) {
        this.$nuxt.error({
          statusCode: 404,
          message: "Новость не найдена"
        });
        return
      }
      this.article = article || {};
      this.isUrlWithId();
    },
    getAllImagesInCmsPage: async function () {
      const content = this.article?.content || '';
      if (!content) return

      const regex = /<img[^>]+src=(["'])(.*?)\1[^>]*>/gi;
      let _images = [];
      let match = '';
      while ((match = regex.exec(content)) !== null) {
        _images.push(match[2]);
      }

      this.parsedImages = _images.map((t) => {
        return `${ process.env.baseApiUrl }${ t }`
      });
    },

    // редирект через 301, т.к по id страница тоже доступна, для сео
    // ВАЖНО: путь абсолютный и с защитой от перехода на себя — раньше отдавался
    // относительный слаг, из-за чего клиент уходил на ту же страницу и попадал
    // в бесконечную перезагрузку (инцидент 29.10.2026)
    isUrlWithId: function () {
      const article = this.article;

      if (!article || !article.id || !article.slug) {
        return;
      }

      const segment = String(this.$route.path || '').split('/').filter(Boolean).pop() || '';

      if (segment !== String(article.id) || String(article.slug) === segment) {
        return;
      }

      return this.$nuxt.context.redirect(301, `/articles/${article.slug}`);
    },
  },
};
